import { IBuilder, IIndexable, key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INVALID_ID } from '../constants/ap_id_constants';
import { APCourseStatusStrategy, ICourseStatus } from '../strategies/ap_course_status_strategy';
import { ap_course_status_type } from '../strategies/ap_course_status_strategy';
import { APSectionType } from './ap_section_type_builder';
import { APTerm } from './ap_term_builder';

export interface IAPCourseMeta extends IIndexable {
  _section_types: APSectionType[];
  id: key;
}

/**
 * old name was PlannerCourseBuilder
 */
export class APCourse implements IIndexable {
  cd: key;
  coreq: never[];
  courseoffered_set: string[];
  credits: number;
  dept: number;
  desc: string;
  id: number;
  is_favorite: boolean;
  favorite_id: number;
  level: number;
  nk: string;
  subject: string;
  has_coreq: boolean;
  has_prereq: boolean;
  title: string;
  status: ap_course_status_type;
  term: key;
  section_types: key[];
  is_planned: boolean;
  _status: ICourseStatus;
  _is_group_course: boolean;
  _title: string;
  _termId: number;

  constructor(course: Partial<APCourse>) {
    _4.merge(
      this,
      {
        courseoffered_set: [],
        coreq: [],
        status: 'DEFAULT',
        is_planned: false,
        is_favorite: false,
        favorite_id: INVALID_ID,
        level: 0,
        _is_group_course: false
      },
      course,
      {
        _termId: INVALID_ID
      }
    );

    this._status = APCourseStatusStrategy.getByKey(this.status);
    this._title = `${this.cd} ${this.title}`;
  }

  static build(course: Partial<APCourse>): APCourse {
    return new APCourse(course);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_course_builder.ts